import { css } from 'styled-components';

const sizes = {
	desktop: 992,
	tablet: 768,
	phone: 576,
	input: 400,
	height: 650,
};

// Iterate through the sizes and create a media template
//
// The short-viewport clause is deliberately paired with a width ceiling. A
// comma is OR in CSS, so `(max-width: X), (max-height: 650px)` alone matched
// *any* short window — a 1280x600 laptop rendered the phone layout, hamburger
// menu and all. Pairing it with `and (max-width: desktop)` keeps the intended
// case (a landscape phone, which is both short and narrow) while leaving wide
// desktops on the desktop layout.
const media = Object.keys(sizes).reduce((acc, label) => {
	acc[label] = (...args) => css`
		@media (max-width: ${sizes[label] / 16}em),
			(max-height: ${sizes.height / 16}em) and
				(max-width: ${sizes.desktop / 16}em) {
			${css(...args)}
		}
	`;

	return acc;
}, {});

export default media;
